module.exports = __webpack_public_path__ + "f60b9043da634440029fc0a68aae5fb7.MP3";